import {Component} from '@angular/core';
import {InfoModalComponent} from "app/views/modal/info_modal.component";
import {getSiteStatusStyle} from "app/lib/lib";

@Component({
	templateUrl: './money_details.component.html'
})
export class MoneyDetailsComponent extends InfoModalComponent {
	public getSiteStatusStyle = getSiteStatusStyle;

	detailLoader: boolean = false;
	details;

	ok() {
		this.close();
	}
}
